import * as React from 'react';
import { compose, setDisplayName } from 'recompose';
import { connect } from 'react-redux';
import { skin, OemProps } from 'ui/styles/skin';
import { CellState, CellIndex, Camera, Stream } from 'types';
import { State } from 'reducers';
import { getActiveCellIndex, getCell, getStreamFromCell, getCameraFromCell } from 'selectors/monitoringSelectors';
import { Fade } from '../../../transitions';
import { VerticalSplitView } from 'ui/shared/SplitView';
import { TimelineView } from './timeline/TimelineView';
import { ZoomControls } from './timeline/ZoomControls';
import { ControllableVideoView } from './ControllableVideoView';
import { activateCell } from 'actions/monitoringActions';
import { Section } from 'ui/shared/Section';

import './MonitoringCell.css';

type Props = OwnProps & StateProps & DispProps & OemProps;

export const RawMonitoringCell = ({ cellIndex, disabled = false, camera, canViewHistorical, onClick, isActive, styles }: Props) =>
    <div
        id={ `monitoring-cell${cellIndex}` }
        className={ `monitoring-cell ${isActive ? 'active' : ''} ${disabled ? 'disabled' : ''}` }
        style={ isActive ? styles.BorderedActive : styles.Bordered }
        onClick={ onClick }
    >
        <Section
            title={ camera && camera.name || '' /* TODO? This is currently just the camera name... maybe also reflect stream # or resolution? */ }
            embed={ () => camera ? <ZoomControls cellIndex={ cellIndex }/> : null }
        >
            <VerticalSplitView value=".25">
                <Fade visible={ canViewHistorical } duration={ 200 }>
                    <TimelineView cellIndex={ cellIndex } />
                </Fade>
                <ControllableVideoView cellIndex={ cellIndex } camera={ camera }/>
            </VerticalSplitView>
        </Section>
    </div>
;

export type OwnProps = {
    cellIndex: CellIndex;
    disabled?: boolean;
};
type StateProps = {
    isActive: boolean;
    cell: CellState | null;
    stream: Stream | null;
    camera: Camera | null;
    canViewHistorical: boolean;
};
type DispProps = {
    onClick: () => void;
};

const mapStateToProps = (state: State, ownProps: OwnProps): StateProps => {
    const camera = getCameraFromCell(state, ownProps);
    return {
        isActive: getActiveCellIndex(state) === ownProps.cellIndex,
        cell: getCell(state, ownProps),
        stream: getStreamFromCell(state, ownProps),
        camera,
        canViewHistorical: !camera || camera.canViewHistorical,
    };
};
const mapDispatchToProps = (dispatch: Function, ownProps: OwnProps): DispProps => ({
    onClick: () => dispatch(activateCell(ownProps.cellIndex)),
});

export const MonitoringCell = compose<Props, OwnProps>(
    setDisplayName('MonitoringCell'),
    skin,
    connect(mapStateToProps, mapDispatchToProps),
)(RawMonitoringCell);



// WEBPACK FOOTER //
// ./src/ui/pages/monitoring/mainPanel/MonitoringCell.tsx